import React, { useEffect } from 'react'
import { Box, FormControl, Grid, Select, MenuItem, TextField, Typography, Button, IconButton } from '@mui/material'
import { useState } from 'react'

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import dayjs from 'dayjs';

import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { MobileTimePicker } from '@mui/x-date-pickers/MobileTimePicker';
import { InputAdornment } from '@mui/material';
import ModalCalendar from '../../components/ModalController/ModalCalendar';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import ModalSuccess from '../../components/ModalController/ModalSuccess'
import * as apiLookup from '../../services/ApiLookup'
import * as apiAppointment from '../../services/ApiAppointment'

import Loader from "../../components/Loader";
import moment from 'moment'
import { notifyInfo, notifyWarning } from '../../components/NotifyToast'


export default function AddAppointment( setAddPage ) {

    const [loading, setLoading] = useState(false);

    const [openCalendar, setOpenCalendar] = useState(false)
    const [SuccessModal, setSucessModal] = useState(false)

    const [findHospital, setFindHospital] = useState([])
    const [findDepartment, setFindDepartment] = useState([])

    const [appoint, setAppoint] = useState({
        appointment_type_code: "AP-100",
        hospital_code: "",
        department_code: "",
        doctor_code: "-",
        date_in: "",
        time_in: "",
        pid: "",
        pname: "",
        fname: "",
        lname: ""

    })

    const [form, setForm] = useState({
        title_name: '',
        fname: '',
        lname: '',
        pid: '',
        name: '',
        department_code: '',
        appoint_date: '',
        appoint_time: ''
    })

    const [dataDay, setDataDay] = useState([
        {
            day: 0,
            status_open: false,
            time_open: "00:00",
            time_close: "00:00"
        },
        {
            day: 1,
            status_open: false,
            time_open: "00:00",
            time_close: "00:00"
        },
        {
            day: 2,
            status_open: false,
            time_open: "00:00",
            time_close: "00:00"
        },
        {
            day: 3,
            status_open: false,
            time_open: "00:00",
            time_close: "00:00"
        },
        {
            day: 4,
            status_open: false,
            time_open: "00:00",
            time_close: "00:00"
        },
        {
            day: 5,
            status_open: false,
            time_open: "00:00",
            time_close: "00:00"
        },
        {
            day: 6,
            status_open: false,
            time_open: "00:00",
            time_close: "00:00"
        }

    ])

    const [disabledDay, setDisabledDay] = useState([])
    const [open, setOpen] = useState({
        open_hours: '',
        open_minutes: '',
    })
    const [close, setClose] = useState({
        close_hours: '',
        close_minutes: '',
    })

    useEffect(() => {
        setTime()
    }, [])

    useEffect(() => {
        setTime()
    }, [form])

    useEffect(() => {
        if (findHospital) {
            let findDepartmentList = findHospital?.filter(d => d.hospital_code === appoint?.hospital_code)
            if (findDepartmentList.length > 0) {
                findDepartmentList = findDepartmentList[0]
                setFindDepartment(findDepartmentList?.department_list)
            } else {
                setFindDepartment([])
            }
        } else {
            setFindDepartment([])
        }
    }, [appoint.hospital_code])

    useEffect(() => {
        fetchDropdownList()
    }, [])

    const fetchDropdownList = async () => {
        apiLookup.lookupHospitalList({
            order: 'hospital_name',
            sort: 'asc'
        }).then(res => {
            if (res.data?.status) {
                if (res.data.data.length === 1) {
                    setAppoint({ ...appoint, hospital_code: res.data.data[0].hospital_code })
                }
                setFindHospital(res.data.data)

            } else {
                setFindHospital([])
            }
        })
    }

    const convertDate = (dataDate) => {
        const date = new Date(dataDate)
        const optionDate = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        }
        const thaiLocale = 'th-TH';
        const formattedDate = date.toLocaleDateString(thaiLocale, optionDate)

        const newDate = `${formattedDate}`
        return newDate
    }


    const setTime = () => {
        // console.log(form['appoint_date']['$W'])

        const findDay = dataDay.filter((item) => item['day'] === form['appoint_date']['$W'])
        // console.log(findDay)
        if (findDay.length > 0) {
            const [hoursStr_open, minutesStr_open] = findDay[0]['time_open'].split(':')
            const hours_open = parseInt(hoursStr_open, 10)
            const minutes_open = parseInt(minutesStr_open, 10)

            open['open_hours'] = hours_open
            open['open_minutes'] = minutes_open

            // setOpen({ ...open, ['open_hours']: hours_open, ['open_minutes']: minutes_open })

            const [hoursStr_close, minutesStr_close] = findDay[0]['time_close'].split(':')
            const hours_close = parseInt(hoursStr_close, 10)
            const minutes_close = parseInt(minutesStr_close, 10)

            close['close_hours'] = hours_close
            close['close_minutes'] = minutes_close

            setClose({ ...close, close_hours: hours_close, close_minutes: minutes_close })
            // console.log(open , close)
        }
    }

    const resetForm = () => {
        setForm({
            title_name: '',
            fname: '',
            lname: '',
            pid: '',
            name: '',
            department_code: '',
            appoint_date: '',
            appoint_time: ''
        })
    }

    const submitForm = async () => {
        // const full_name = `${form['title_name']} ${form['fname']} ${form['lname']}`
        // form['name'] = full_name


        if (!appoint['pid']) {
            return notifyWarning("กรุณากรอก เลขบัตรประจำตัวประชาชน")
        }
        if (appoint['pid'].length < 13) {
            return notifyWarning("กรุณากรอก เลขบัตรประจำตัวประชาชน")
        }
        if (!appoint['pname']) {
            return notifyWarning("กรุณากรอก คำนำหน้า")
        }
        if (!appoint['fname']) {
            return notifyWarning("กรุณากรอก ชื่อ")
        }
        if (!appoint['lname']) {
            return notifyWarning("กรุณากรอก นามสกุล")
        }

        if (!appoint['hospital_code']) {
            return notifyWarning("กรุณากรอก โรงพยาบาล")
        }

        if (!appoint['department_code']) {
            return notifyWarning("กรุณากรอก แผนก")
        }
        if (!appoint['date_in']) {
            return notifyWarning("กรุณากรอก วันที่ต้องการนัดหมาย")
        }
        if (!appoint['time_in']) {
            return notifyWarning("กรุณากรอก เวลาต้องการนัดหมาย")
        }

        appoint['date_in'] = moment(appoint['date_in']['$d']).format('YYYY-MM-DD')
        appoint['time_in'] = moment(appoint['time_in']['$d']).format('HH:mm')


        setLoading(true)
        let res = await apiAppointment.appointmentAdd(appoint)
        // setLoading(false)
        if (res?.data?.status) {
            setLoading(false)
            setSucessModal(true)
            setAppoint({
                ...appoint,
                pname: '',
                fname: '',
                lname: '',
                pid: '',
                department_code: '',
                date_in: '',
                time_in: ''
            })
        } else {
            setLoading(false)
            return notifyInfo(res['data']['message'])

        }

    }

    return (
    <>
        {loading && <Loader loading={loading} />}

        {openCalendar && <ModalCalendar
            onClose={() => { setOpenCalendar(!openCalendar) }}
            value={appoint['date_in'] ? dayjs(moment(appoint['date_in']['$d']).format('YYYY-MM-DD')) : dayjs(moment(new Date()).format('YYYY-MM-DD'))}
            onChange={(e) => {
                setAppoint({ ...appoint, date_in: e })
            }}
            disableDay={disabledDay}
            onFinished={(paramsState => {
                if (paramsState === 'eiei') {
                    setTime()
                }
            })}
        />}
        {SuccessModal && <ModalSuccess
            title='นัดหมายสำเร็จ'
            detail='ท่านได้เพิ่มการนัดหมายเรียบร้อยแล้ว'
            closeModal={() => { setSucessModal(false); setAddPage(false); }}
            goPage={'closeModal'}
        />}

        <Box
            sx={{
                border: 1,
                my: '0.3rem',
                borderRadius: 2,
                borderColor: '#E1E3E9',
                padding: '20px',
                display: 'grid',
                gap: '20px',
                mt: '50px',
                bgcolor: '#FFF',
            }}
        >
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6} sx={{
                    width: '100%',
                }}>
                    <Typography sx={{ fontSize: '18px', mb: '0.5rem', fontWeight: 'bold' }}>
                        โรงพยาบาลที่เข้ารับบริการ
                    </Typography>
                    <FormControl fullWidth>
                        <Select
                            placeholder={'โรงพยาบาล'}
                            name='hospital_code'
                            value={appoint['hospital_code'] || ' '}
                            onChange={(e) => {
                                const {
                                    target: { value }
                                } = e
                                setAppoint({ ...appoint, hospital_code: value })
                            }}
                        >
                            <MenuItem value=" ">เลือกโรงพยาบาล</MenuItem>
                            {
                                findHospital.map((item, idex) => (
                                    <MenuItem key={`d_${idex}`} value={item['hospital_code']}>{item['hospital_name']}</MenuItem>
                                ))
                            }
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Typography sx={{ fontSize: '18px', mb: '0.5rem', fontWeight: 'bold' }}>
                        แผนกที่เข้ารับบริการ
                    </Typography>
                    <FormControl fullWidth>
                        <Select
                            name='department_code'
                            value={appoint['department_code'] || ' '}
                            onChange={(e) => {
                                const {
                                    target: { value }
                                } = e
                                // console.log(value)
                                setAppoint({ ...appoint, department_code: value })
                                // findOneDepartment(value)
                            }}
                        >
                            <MenuItem value=" ">เลือกแผนก</MenuItem>
                            {
                                findDepartment.map((item, idex) => (
                                    <MenuItem key={`d_${idex}`} value={item['department_code']}>{item['department_name']}</MenuItem>
                                ))
                            }
                        </Select>
                    </FormControl>
                </Grid>
            </Grid>

            <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                    <Typography sx={{ fontSize: '18px', mb: '0.5rem', fontWeight: 'bold' }}>
                        เลือกวันที่ต้องการนัดหมาย
                    </Typography>

                    <TextField
                        value={appoint['date_in'] ? convertDate(appoint['date_in']) : 'เลือกวันที่ต้องการ'}
                        fullWidth
                        // disabled={false}
                        // error={form['appoint_date'] ? false : true }

                        placeholder={'เลือกวันที่ต้องการนัดหมาย'}
                        InputProps={{
                            inputProps: {
                                readOnly: true,
                            },
                            endAdornment: (
                                <InputAdornment position='end'>
                                    <IconButton onClick={() => {
                                        setOpenCalendar(true)
                                    }}>
                                        <CalendarTodayIcon />
                                    </IconButton>
                                </InputAdornment>
                            )
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Typography sx={{ fontSize: '18px', fontWeight: 'bold' }}>
                        เลือกเวลาต้องการนัดหมาย
                    </Typography>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer
                            components={[
                                'MobileTimePicker',
                            ]}
                        >
                            <MobileTimePicker
                                // locale={thLocale}
                                ampm={false}
                                sx={{ width: '100%' }}
                                value={
                                    appoint['time_in'] ?
                                        dayjs(moment(appoint['time_in']['$d']).format('YYYY-MM-DDTHH:mm'))
                                        :
                                        dayjs(moment(new Date()).format('YYYY-MM-DDTHH:mm')).set('hour', 0).set('minute', 0)
                                }
                                onChange={
                                    (e) => setAppoint({ ...appoint, time_in: e })
                                }

                            // minTime={
                            //     open ?
                            //         dayjs().set('hour', open['open_hours']).set('minute', open['open_minutes']) : null
                            // }
                            // maxTime={
                            //     close ?
                            //         dayjs().set('hour', close['close_hours']).set('minute', close['close_minutes']) : null
                            // }



                            />
                        </DemoContainer>
                    </LocalizationProvider>
                </Grid>
            </Grid>

            <Grid justifyContent={'center'} container gap={'20px'}>
                <Button variant='outlined'
                    onClick={() => resetForm()}
                >
                    ยกเลิก
                </Button>
                <Button variant='contained'
                    // onClick={() => { setSucessModal(true) }}
                    onClick={() => submitForm()}
                >
                    บันทึก
                </Button>
            </Grid>
        </Box >
    </>);
}